module.exports = function() {
  return new Worker(__webpack_public_path__ + "702e9feb84ebca463c8d.worker.js");
};